import React from "react";

import Background from "../../../assets/cleaning/cleaning-bg-01.png";

import GamePageLayout from "../GamePageLayout";

const CleaningPage1 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      onClickNext={() => setCurrentPage("cleaning-2")}
    >
      방 청소를 못했더니 엉망이네.
      <br />
      바닥만 쓸고 잠들어야겠다.
    </GamePageLayout>
  );
};

export default CleaningPage1;
